"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_1 = require("@nimles/react-web-components");

var Link_1 = require("./Link");

var StyledBrand = styled_1.default(Link_1.NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 32px;\n  height: 48px;\n  letter-spacing: 1px;\n  text-align: left;\n  text-decoration: none;\n  padding: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #fff;\n  font-family: 'Lato', sans-serif;\n  margin-bottom: 0;\n\n  @media (min-width: ", "px) {\n    padding: 8px 32px;\n  }\n"], ["\n  color: ", ";\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 32px;\n  height: 48px;\n  letter-spacing: 1px;\n  text-align: left;\n  text-decoration: none;\n  padding: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #fff;\n  font-family: 'Lato', sans-serif;\n  margin-bottom: 0;\n\n  @media (min-width: ", "px) {\n    padding: 8px 32px;\n  }\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.onColor, _e !== null && _e !== void 0 ? _e : react_web_components_1.defaultTheme.colors.primary.onColor;
}, function (props) {
  var _a, _b, _c;

  return _c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b.sm, _c !== null && _c !== void 0 ? _c : react_web_components_1.defaultTheme.thresholds.sm;
});
var Logo = styled_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 32px;\n"], ["\n  height: 32px;\n"])));

exports.Brand = function (_a) {
  var showLogo = _a.showLogo,
      showName = _a.showName;
  var tenant = react_redux_1.useSelector(function (_a) {
    var publicTenants = _a.publicTenants;
    return publicTenants.selected;
  });
  var organization = react_redux_1.useSelector(function (_a) {
    var publicOrganizations = _a.publicOrganizations;
    return publicOrganizations.selected;
  });
  var logoId = organization ? organization.logoId : tenant.logoId;
  var logoUrl = logoId && "https://media.nimles.com/file/" + tenant.id + "/" + logoId;
  var name = organization ? organization.name : tenant.name;

  if (!showLogo && !showName) {
    if (logoUrl) {
      showLogo = true;
    } else {
      showName = true;
    }
  }

  return react_1.default.createElement(StyledBrand, {
    to: "/"
  }, showLogo && react_1.default.createElement(Logo, {
    src: logoUrl,
    alt: name
  }), showName && react_1.default.createElement("span", null, name));
};

var templateObject_1, templateObject_2;